import React from "react";
import { Icon } from "@chakra-ui/icons";

import { ReactComponent as ArrowDropRightLineIcon } from "../../assets/arrow-drop-right-line.svg";

export const ArrowDropRightLine = (props) => {
  return <Icon as={ArrowDropRightLineIcon} {...props} />;
};
